<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useProductPageStore } from "~/stores/main";

// -----------------------
// composables
// -----------------------
const store = useProductPageStore();
const { getAssetUrl, getVariantByProperty, totalStockOfVariant } = useHelpers();
const route = useRoute();
const { masterProduct, currentImageIndex } = storeToRefs(store);

// -----------------------
// computed properties
// -----------------------
const images = computed(() => {
  if (!masterProduct.value) {
    return [];
  }

  const products = masterProduct.value.products;
  const productsInStock = products.filter(
    (variant) => totalStockOfVariant(variant) > 0,
  );
  let defaultColor;

  if (products.length === 1) {
    defaultColor = products[0].product.product_szin_property;
  } else if (productsInStock.length > 0) {
    defaultColor = productsInStock[0].product.product_szin_property;
  } else {
    defaultColor = products[0].product.product_szin_property;
  }

  // Select variant with the specified palette on load
  if ("color" in route.query) {
    const color = decodeURIComponent("" + route.query.color);
    const variantWithColor = getVariantByProperty(
      masterProduct.value,
      "product_szin_property",
      color,
    );

    if (variantWithColor) {
      defaultColor = color;
    }
  }

  if (defaultColor !== null) {
    store.color = defaultColor;
    const variantWithColor = getVariantByProperty(
      masterProduct.value,
      "product_szin_property",
      defaultColor,
    );

    if (variantWithColor) {
      return variantWithColor.images.map((src) => getAssetUrl(src));
    }
  }

  return [];
});

// -----------------------
// vue events
// -----------------------
if (import.meta.client) {
  watch(images, () => {
    currentImageIndex.value = 0;
  });
}
</script>

<template>
  <!-- Mobile -->
  <ProductPageGalleryMobile :images="images" />

  <!-- Desktop -->
  <ProductPageGalleryDesktop :images="images" />
</template>
